import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
import { PatientSelectorService } from './patient-selector.service';

@Component({
  selector: 'app-patient-selector',
  templateUrl: './patient-selector.component.html',
  styleUrls: ['./patient-selector.component.scss']
})
export class PatientSelectorComponent implements OnInit {

  @ViewChild('patientSearchInput', { static: true }) patientSearchInput: ElementRef;

  @Input() showSelectedUser: boolean;

  patientsOptions: Observable<Patient[]>;
  selectedPatient: Patient;

  constructor(private patientService: PatientService, private patientSelectorService: PatientSelectorService, private physicianOptionService: PhysicianOptionService) { }

  ngOnInit() {
    this.patientSelectorService.selectionChange$.subscribe(
      (patient) => { this.selectedPatient = patient },
      (error) => { console.error(error); }
    );

    fromEvent(this.patientSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(300)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.unselectPatient();
      this.searchPatient(text);
    });
  }

  searchPatient(patientName: string): void {
    this.patientsOptions=this.patientService.getPatientDetailsByPractitionerAndName(this.physicianOptionService.getPhysician().npi, patientName).pipe
      (
        startWith([]),

      
      // (error) => { console.error(error); }
    );
  }

  selectPatient(patient: Patient): void {
    console.log(patient);
    this.patientSearchInput.nativeElement.value='';
    this.selectedPatient = patient;
    this.patientSelectorService.setPatient(patient);
  }

  unselectPatient(): void {
    this.selectedPatient = undefined;
    this.patientSelectorService.setPatient(undefined);
  }

}
